// extracted by mini-css-extract-plugin
module.exports = {"background":"AnnouncementPage_background__1hi56","header":"AnnouncementPage_header__3hWbW","body":"AnnouncementPage_body__2VaSI"};